import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded'
import EmailRoundedIcon from '@mui/icons-material/EmailRounded'
import MutationMenuItem from 'components/Control/ActionMenuItem/MutationMenuItem'
import {
    useResolveFaultLogMutation,
    useUpdateMeterReadingValueMutation,
    useResendInvoiceMutation,
    useCancelInvoiceMutation,
    useRefreshPaymentTokenMutation,
    useSendUnpaidInvoicesToConsumerMutation,
} from 'store/Store'
import {useSendAgainMutation} from 'store/slices/api/invitesApi'
import CachedRoundedIcon from '@mui/icons-material/CachedRounded'
import OpenPaymentMenuItem from 'components/Control/ActionMenuItem/OpenPaymentMenuItem'
import ConfirmMutationMenuItem from 'components/Control/ActionMenuItem/ConfirmMutationMenuItem'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import MeterSyncMenuItem from 'components/Control/ActionMenuItem/MeterSyncMenuItem'
import BeforeCloseMutationMenuItem from 'components/Control/ActionMenuItem/BeforeCloseMutationMenuItem'
import InvoiceDownloadMenuItem from 'components/Control/ActionMenuItem/InvoiceDownloadMenuItem'
import NewMeterMenuItem from 'components/Control/ActionMenuItem/NewMeterMenuItem'
import SetLastMeterReadingMenuItem from 'components/Control/ActionMenuItem/SetLastMeterReadingMenuItem'
import SwapHorizRoundedIcon from '@mui/icons-material/SwapHorizRounded'
import BookmarkRoundedIcon from '@mui/icons-material/BookmarkRounded'

const rateTableActions = [
    {
        MenuItem: InvoiceDownloadMenuItem,
        title: 'download',
        Icon: GetAppRoundedIcon,
        translationKey: 'invoices.download',
    },
    {
        MenuItem: BeforeCloseMutationMenuItem,
        title: 'resend_invoice',
        useMutation: useResendInvoiceMutation,
        Icon: EmailRoundedIcon,
        translationKey: 'invoices.resend',
    },
    {
        MenuItem: ConfirmMutationMenuItem,
        title: 'cancel_invoice',
        useMutation: useCancelInvoiceMutation,
        Icon: CancelRoundedIcon,
        translationKey: 'invoices.cancel',
    },
]

const inviteTableActions = [
    {
        MenuItem: MutationMenuItem,
        title: 'send_again',
        useMutation: useSendAgainMutation,
        Icon: EmailRoundedIcon,
        translationKey: 'invites.sendAgain',
    },
]

const meterReadingTableActions = [
    {
        MenuItem: MutationMenuItem,
        title: 'update_value',
        useMutation: useUpdateMeterReadingValueMutation,
        Icon: CachedRoundedIcon,
        translationKey: 'meter_readings.updateValue',
    },
    {
        MenuItem: NewMeterMenuItem,
        title: 'mark_new_meter',
        Icon: SwapHorizRoundedIcon,
    },
    {
        MenuItem: SetLastMeterReadingMenuItem,
        title: 'set_last_meter_reading',
        Icon: BookmarkRoundedIcon,
    },
]

const faultLogTableActions = [
    {
        MenuItem: MutationMenuItem,
        title: 'resolve_fault',
        useMutation: useResolveFaultLogMutation,
        Icon: CachedRoundedIcon,
        translationKey: 'fault_logs.resolveFault',
    },
]

const paymentsTableActions = [
    {
        MenuItem: OpenPaymentMenuItem,
        title: 'open_payment',
    },
    {
        MenuItem: ConfirmMutationMenuItem,
        title: 'refresh_payment_token',
        useMutation: useRefreshPaymentTokenMutation,
        Icon: CachedRoundedIcon,
        translationKey: 'payments.refreshToken',
    },
]

const consumersTableActions = [
    {
        MenuItem: ConfirmMutationMenuItem,
        title: 'send_unpaid_invoices',
        useMutation: useSendUnpaidInvoicesToConsumerMutation,
        Icon: EmailRoundedIcon,
        translationKey: 'consumers.send_unpaid_invoices',
    },
]

const meterTableActions = [
    {
        MenuItem: MeterSyncMenuItem,
        title: 'sync_meter',
        Icon: CachedRoundedIcon,
        translationKey: 'meters.sync',
    },
]

const tableActions = {
    rateTableActions,
    inviteTableActions,
    meterReadingTableActions,
    faultLogTableActions,
    paymentsTableActions,
    consumersTableActions,
    meterTableActions,
}

export default tableActions
